'use client'
import { createStoreState } from '../internalImplementation/utils/createStoreState/createStoreState.js';

const { getEnvironmentId, useEnvironmentId, setEnvironmentId } = createStoreState('environmentId');

export { getEnvironmentId, setEnvironmentId, useEnvironmentId };
